import Home from '@/views/Home.vue'
import PageIndex from '@/components/Utils/PageIndex.vue'

import ContainerList from '@/views/Setting/Container/ContainerList.vue'
// import ContainerIndex from '@/views/Container/ContainerIndex.vue'
import ExperimentList from '@/views/OptimizePage/Experiment/ExperimentList.vue'
import VersionList from '@/views/OptimizePage/Experiment/VersionList.vue'
import OptimizePageEditorApp from '@/views/OptimizePage/Experiment/OptimizePageEditorApp.vue'

// import StaffIndex from '@/views/Setting/Staff/StaffIndex.vue'
import StaffList from '@/views/Setting/Staff/StaffList.vue'
import StaffEdit from '@/views/Setting/Staff/StaffEdit.vue'
import StaffMemberLevel from '@/views/Setting/Subscription/StaffMemberLevel.vue'

import PluginSettingList from '@/views/OptimizePage/PagePlugin/List.vue'
import PluginSettingEdit from '@/views/OptimizePage/PagePlugin/Edit.vue'
import PluginPageEditor from '@/views/OptimizePage/PagePlugin/PageEditor/OptimizePageEditorApp.vue'

// import MarketingToolIndex from '@/views/MarketingTool/MarketingToolIndex.vue'
import TimerList from '@/views/OptimizePage/IframeTimer/TimerList.vue'
import TimerEditor from '@/views/OptimizePage/IframeTimer/TimerEditor.vue'
import InvoiceList from '@/views/OptimizePage/InvoiceCollector/InvoiceList.vue'
import InvoiceEditor from '@/views/OptimizePage/InvoiceCollector/InvoiceEditor.vue'
import InvoiceData from '@/views/OptimizePage/InvoiceCollector/InvoiceData.vue'

import DetectLogin from '@/views/OptimizeCheckout/Login/DetectLogin.vue'

import GlobalSettingList from '@/views/OptimizeSite/GlobalSetting/List.vue'
import SearchList from '@/views/OptimizeSite/InterestingSearch/SearchList.vue'

import Organization from '@/views/Setting/Organization/Organization.vue'

import BatchList from '@/views/ExportBatch/BatchList.vue'
import WaterMarkerList from '@/views/OptimizeCategory/WaterMarkerList.vue'
import WaterMarkerEdit from '@/views/OptimizeCategory/WaterMarkerEdit.vue'

import ImageGallery from '@/views/OptimizePage/imageGallery.vue'
import ReadmeMap from '@/views/PartnerFeature/ReadmeMap.vue'

// import store from "../store/index.js";

// import NotifyIndex from "@/views/Notify/NotifyIndex.vue"
// import NotifyList from "@/views/Notify/NotifyList.vue"
// import ChannelList from "@/views/Notify/ChannelList.vue"
// import ProductList from "@/views/Notify/ProductList.vue"

// import NotFound from "@/views/Error/NotFound.vue";

// import Demo from '@/views/Demo/Demo.vue'
// import TransactionId from '@/views/Demo/TransactionId.vue'
// import CopyWriting from '@/views/Demo/CopyWriting.vue'
// import OutOfStockrReminder from '@/views/Demo/OutOfStockrReminder.vue'
// import LimitedArea from 's@/views/Demo/LimitedArea.vue'

// import MarketingCardIndex from '@/views/MarketingCard/MarketingCardIndex.vue'
// import MarketingCardEdit from '@/views/MarketingCard/MarketingCardEdit.vue'

const private_routes = [
  {
    icon: 'mdi-home',
    name: '首頁',
    path: '/:org_id/home',
    link_path: '',
    component: Home,
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: '首頁',
          disabled: true,
        },
      ],
      is_required_login: true,
    },
  },
  {
    icon: 'mdi-home',
    name: '首頁',
    path: '/:org_id/:container_id/home',
    link_path: '',
    component: Home,
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: '首頁',
          disabled: true,
        },
      ],
      is_required_login: true,
    },
  },
  {
    icon: 'mdi-toolbox',
    name: '站台優化',
    path: '/:org_id/:container_id/optimize_site/',
    link_path: '',
    feature: 'optimize_site',
    component: PageIndex,
    // component: () => import('@/views/MarketingCard/MarketingCardIndex.vue'),
    // component: () => import('@/views/MarketingCard/MarketingCardSettingSettingCardList.vue'),
    children: [
      // {
      // 	feature: 'ad',
      // 	path: "/ad/marketing_card/:container_id/marketing_card_list",
      // 	name: "站台優化",
      // 	component: () => import('@/views/MarketingCard/MarketingCardSettingSettingCardList.vue'),
      // },
      {
        feature: 'marketing_card',
        path: '/:org_id/:container_id/optimize_site/marketing_card/',
        link_path: 'optimize_site/marketing_card/',
        name: '行銷圖卡',
        component: () => import('@/views/OptimizeSite/MarketingCard/MarketingCardSettingSettingCardList.vue'),
        meta: {
          breadcrumbs: [
            {
              text: '站台優化',
              disabled: true,
            },
            {
              text: '行銷圖卡',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        path: '/:org_id/:container_id/optimize_site/marketing_card/edit',
        link_path: 'optimize_site/marketing_card/edit',
        name: '行銷圖卡編輯器',
        component: () => import('@/views/OptimizeSite/MarketingCard/MarketingCardEdit.vue'),
        meta: {
          breadcrumbs: [
            {
              text: '站台優化',
              disabled: true,
            },
            {
              text: '行銷圖卡',
              disabled: false,
            },
            {
              text: '新增',
              disabled: true,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'floating_menu_setting',
        path: '/:org_id/:container_id/optimize_site/floating_menu_setting',
        link_path: 'optimize_site/floating_menu_setting',
        name: '社群浮球',
        invisibility_sidebar: true,
        component: () => import('@/views/OptimizeSite/FloatingMenuSetting.vue'),
        meta: {
          is_required_login: true,
        },
      },
      {
        feature: 'interesting_search',
        path: '/:org_id/:container_id/optimize_site/interesting_search/',
        link_path: 'optimize_site/interesting_search/',
        component: SearchList,
        name: '興趣搜尋',
        invisibility_sidebar: true,
        show_levels: ['nineder'],
        meta: {
          breadcrumbs: [
            {
              text: '站台優化',
              disabled: true,
            },
            {
              text: '興趣搜尋',
              disabled: false,
            },
          ],
          is_required_login: true,
          activate_levels: ['Nineder'],
        },
      },
      {
        feature: 'global_setting',
        path: '/:org_id/:container_id/optimize_site/global_setting/',
        link_path: 'optimize_site/global_setting/',
        name: '一鍵換圖',
        component: GlobalSettingList,
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: '站台優化',
              disabled: true,
            },
            {
              text: '一鍵換圖',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      // {
      // 	feature: 'ad',
      // 	path: "/ad/marketing_card/edit",
      // 	name: "行銷圖卡編輯器",
      // 	component: () => import('@/views/MarketingCard/MarketingCardEdit.vue'),
      // },
      // {
      // 	feature: 'ad',
      // 	path: "/ad/marketing_card/countdown_timer",
      // 	name: "站台優化",
      // 	component: () => import('@/views/MarketingCard/CountDownTimerEditor.vue'),
      // 	children: [
      // 		{
      // 			feature: 'ad',
      // 			path: "/ad/marketing_card/countdown_timer",
      // 			name: "倒數計時器設定",
      // 			component: () => import('@/views/MarketingCard/CountDownTimerList.vue'),
      // 		},
      // 		{
      // 			feature: 'ad',
      // 			path: "/ad/marketing_card/ad_tool/countdown_timer/edit",
      // 			name: "iframe倒數計時器樣式設定",
      // 			component: () => import('@/views/MarketingCard/CountDownTimerEditor.vue'),
      // 		}
      // 	]
      // },
    ],
  },
  // {
  // 	icon: "mdi-collage",
  // 	name: '目錄優化',
  // 	path: '/optimize_category',
  // 	feature: 'optimize_category',
  // 	component: () => import('@/views/Demo//testMenu.vue'),
  // },
  {
    icon: 'mdi-image-multiple',
    name: '頁面優化',
    path: '/:org_id/:container_id/container',
    link_path: '',
    feature: 'optimize_page',
    component: PageIndex,
    children: [
      {
        feature: '',
        path: '/:org_id/:container_id/container',
        link_path: '',
        name: '容器',
        component: ContainerList,
        meta: {
          is_required_login: true,
        },
      },
      {
        feature: 'experiments',
        path: '/:org_id/:container_id/optimize_page/experiments',
        link_path: 'optimize_page/experiments/',
        name: '實驗',
        component: ExperimentList,
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '實驗',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'version',
        path: '/:org_id/:container_id/optimize_page/experiments/:experiment_id/',
        link_path: '',
        name: '版本',
        component: VersionList,
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '實驗',
              disabled: false,
            },
            // {
            // 	"text": "版本",
            // 	disabled: true,
            // }
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'page_editor',
        path: '/:org_id/:container_id/optimize_page/page_editor',
        link_path: '',
        name: '頁面編輯器',
        component: OptimizePageEditorApp,
        invisibility_sidebar: true,
        meta: {
          is_required_login: true,
        },
      },
      {
        feature: 'iframe_timer',
        path: '/:org_id/:container_id/optimize_page/iframe_timer/new',
        link_path: 'optimize_page/iframe_timer/new',
        name: '編輯',
        component: TimerEditor,
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '倒數計時器',
              disabled: false,
            },
            {
              text: '新增',
              disabled: true,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'iframe_timer',
        path: '/:org_id/:container_id/optimize_page/iframe_timer/:iframe_id/edit',
        link_path: '',
        name: '修改',
        component: TimerEditor,
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '倒數計時器',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'page_plugin',
        path: '/:org_id/:container_id/optimize_page/page_plugin/',
        link_path: 'optimize_page/page_plugin/',
        name: '衝動外掛',
        component: PluginSettingList,
        invisibility_sidebar: false,
        meta: {
          breadcrumbs: [
            {
              text: '衝動外掛',
              disabled: true,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'sale_counter',
        path: '/:org_id/:container_id/optimize_page/page_plugin/:id',
        name: '編輯衝動外掛',
        component: PluginSettingEdit,
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: '衝動外掛',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'sale_counter',
        path: '/:org_id/:container_id/optimize_page/page_plugin/page_editor/:id',
        name: '編輯頁面',
        component: PluginPageEditor,
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [],
          is_required_login: true,
        },
      },
      {
        feature: 'iframe_timer',
        path: '/:org_id/:container_id/optimize_page/iframe_timer/',
        link_path: 'optimize_page/iframe_timer/',
        name: '倒數計時器',
        component: TimerList,
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '倒數計時器',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'invoice_collector',
        path: '/:org_id/:container_id/optimize_page/invoice_collector/',
        link_path: 'optimize_page/invoice_collector/',
        name: '發票蒐集器',
        component: InvoiceList,
        invisibility_sidebar: true,
        show_levels: ['nineder'],
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '發票蒐集器',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        invisibility_sidebar: true,
        feature: 'invoice_collector',
        path: '/:org_id/:container_id/optimize_page/invoice_collector/:id',
        link_path: 'optimize_page/invoice_collector/:id',
        name: '發票蒐集器',
        component: InvoiceEditor,
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '發票蒐集器',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        invisibility_sidebar: true,
        feature: 'invoice_collector',
        path: '/:org_id/:container_id/optimize_page/invoice_collector/:id/data',
        link_path: 'optimize_page/invoice_collector/:id/data',
        name: '發票資料',
        component: InvoiceData,
        meta: {
          breadcrumbs: [
            {
              text: '頁面優化',
              disabled: true,
            },
            {
              text: '發票資料',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-cart-arrow-up',
    name: '結帳優化',
    path: '/:org_id/:container_id/optimize_checkout',
    link_path: '',
    feature: 'optimize_checkout',
    component: PageIndex,
    children: [
      {
        feature: 'login',
        path: '/:org_id/:container_id/optimize_checkout/login',
        link_path: 'optimize_checkout/login',
        name: '登入異常',
        component: DetectLogin,
        invisibility_sidebar: false,
        meta: {
          breadcrumbs: [
            {
              text: '結帳優化',
              disabled: true,
            },
            {
              text: '登入異常',
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  // {
  //     icon: "mdi-message-badge",
  // 	name: '缺貨提醒',
  // 	path: '/notify/organization',
  //     component: NotifyIndex,
  // 	feature: 'notify',
  // 	children: [
  // 		{
  // 			feature: 'notify',
  // 			path: "/notify/organization",
  // 			name: "缺貨提醒",
  // 			component: NotifyList
  // 		},
  // 		{
  // 			feature: 'notify',
  // 			path: "/notify/orgnization/:orgnization_id/sales_channel",
  // 			name: "缺貨提醒",
  // 			component: ChannelList
  // 		},
  // 		{
  // 			feature: 'notify',
  // 			path: "/notify/orgnization/:orgnization_id/sales_channel/:sales_channel_id/products",
  // 			name: "缺貨提醒",
  // 			component: ProductList
  // 		}
  // 	]
  // },
  // {
  // 	path: "/:container_id/setting/:feature",
  // 	name: "設定",
  // 	feature: 'setting',
  // 	component: StaffList,
  // 	invisibility_sidebar: true,
  // 	// 如果要靜態的話，照這個格式設定就可以了
  // 	meta: {
  // 		breadcrumbs: [
  // 			{
  // 				"text": "設定"
  // 			},
  // 			{
  // 				"text": "管理員"
  // 			},
  // 		]
  // 	}
  // },
  {
    icon: 'mdi-file-export-outline',
    name: '資料匯出',
    path: '/:org_id/:container_id/export/',
    link_path: '',
    component: PageIndex,
    feature: 'job',
    invisibility_sidebar: true,
    show_levels: ['nineder'],
    meta: {
      breadcrumbs: [
        {
          text: '資料匯出',
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        feature: 'job',
        path: '/:org_id/:container_id/export/jobs/',
        link_path: 'export/jobs/',
        name: '作業進度',
        component: BatchList,
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: '資料匯出',
              disabled: true,
            },
            {
              text: '作業進度',
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-folder-outline',
    name: '目錄優化',
    path: '/:org_id/:container_id/category/',
    link_path: '',
    component: PageIndex,
    feature: 'category',
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: '目錄優化',
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        feature: 'category',
        path: '/:org_id/:container_id/category/water_marker/',
        link_path: 'category/water_marker/',
        name: '浮水印',
        component: WaterMarkerList,
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: '目錄優化',
              disabled: true,
            },
            {
              text: '浮水印',
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'category',
        path: '/:org_id/:container_id/category/water_marker/edit',
        link_path: 'category/water_marker/edit',
        name: '浮水印設定',
        component: WaterMarkerEdit,
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: '目錄優化',
              disabled: true,
            },
            {
              text: '浮水印',
            },
            {
              text: '新增',
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-tools',
    name: '其他功能',
    path: '/:org_id/:container_id/toolbox/',
    link_path: '',
    component: PageIndex,
    feature: 'toolbox',
    invisibility_sidebar: false,
    meta: {
      breadcrumbs: [
        {
          text: '其他功能',
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        name: '圖片庫',
        path: '/:org_id/:container_id/toolbox/image_gallery',
        link_path: 'toolbox/image_gallery',
        component: ImageGallery,
        is_sidebar_bottom: false,
        invisibility_sidebar: false,
        meta: {
          breadcrumbs: [
            {
              text: '其他功能',
              disabled: true,
            },
            {
              text: '圖片庫',
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-handshake',
    name: '協作功能',
    path: '/:org_id/:container_id/partner/',
    link_path: '',
    component: PageIndex,
    feature: 'partner',
    invisibility_sidebar: true,
    show_levels: ['nineder', 'bussiness', 'starter', 'free', 'disabled'],
    meta: {
      breadcrumbs: [
        {
          text: '協作功能',
        },
      ],
      is_required_login: true,
      is_required_partner_user: true,
    },
    children: [
      {
        feature: 'partner',
        path: '/:org_id/:container_id/partner/readme_map',
        link_path: 'partner/readme_map',
        name: '前台說明設定',
        component: ReadmeMap,
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: '協作功能',
              disabled: true,
            },
            {
              text: '前台說明設定',
            },
          ],
          is_required_login: true,
          is_required_partner_user: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-cog',
    name: '設定',
    path: '/:org_id/setting/',
    link_path: '',
    component: PageIndex,
    feature: 'setting',
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: '設定',
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        feature: 'staff',
        path: '/:org_id/setting/staffs/',
        link_path: 'setting/staffs/',
        name: '成員',
        component: StaffList,
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: '組織設定',
            },
            {
              text: '成員',
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'containers',
        path: '/:org_id/setting/containers/:container_id/edit',
        name: '編輯容器',
        component: () => import('@/views/Setting/Container/ContainerEdit.vue'),
        meta: {
          breadcrumbs: [
            {
              text: '組織設定',
            },
            {
              text: '容器',
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'containers',
        path: '/:org_id/setting/containers',
        link_path: 'setting/containers',
        name: '容器',
        component: () => import('@/views/Setting/Container/ContainerList.vue'),
        meta: {
          breadcrumbs: [
            {
              text: '組織設定',
            },
            {
              text: '容器',
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        path: '/:org_id/setting/staffs/:staff_id/edit',
        link_path: '',
        name: '管理員',
        component: StaffEdit,
        // 如果要動態的話，看StaffEdit這個元件
        // 1. created 先用commit update_breadcrumbs 更新 vuex裡面的replace_breadcrumbs
        // 2. beforeRouteLeave，再用commit update_breadcrumbs ，清空這個元件強迫顯示的replace_breadcrumbs
        meta: {
          breadcrumbs: [
            {
              text: '組織設定',
            },
            {
              text: '成員',
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        path: '/:org_id/setting/subscription/',
        link_path: 'setting/subscription/',
        name: '訂閱',
        component: StaffMemberLevel,
        meta: {
          breadcrumbs: [
            {
              text: '組織設定',
            },
            {
              text: '訂閱',
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        path: '/:org_id/setting/organization',
        link_path: 'setting/organization',
        name: '組織',
        component: Organization,
        meta: {
          breadcrumbs: [
            {
              text: '組織設定',
            },
            {
              text: '組織',
            },
          ],
          is_required_login: true,
        },
      },
      // {
      // 	feature: '',
      // 	path: "/:org_id/setting/subscription/upgrade",
      // 	link_path: '',
      // 	name: "訂閱",
      // 	component: () => ('@/views/Setting/Staff/StaffMemberPlanUpgrade.vue'),
      // 	// 如果要動態的話，看StaffEdit這個元件
      // 	// 1. created 先用commit update_breadcrumbs 更新 vuex裡面的replace_breadcrumbs
      // 	// 2. beforeRouteLeave，再用commit update_breadcrumbs ，清空這個元件強迫顯示的replace_breadcrumbs
      // 	meta: {
      // 		breadcrumbs: [
      // 			{
      // 				"text": "設定"
      // 			},
      // 			{
      // 				"text": "訂閱"
      // 			},
      // 			{
      // 				"text": "升級"
      // 			}
      // 		],
      // 		is_required_login: true,
      // 	}
      // },
    ],
  },
  // {
  // 	icon: "mdi-playlist-check",
  // 	name: '訂閱與收費',
  // 	path: '/:org_id/:container_id/subscription',
  // 	link_path: '',
  //     component: () => import('@/views/Subscription/SubscriptionIndex.vue'),
  // 	feature: 'subscription',
  // 	invisibility_sidebar: true,
  // 	children: [
  // 		// {
  // 		// 	feature: 'subscription',
  // 		// 	path: "/:org_id/:container_id/subscription/member_level",
  // 		// 	link_path: 'subscription/member_level',
  // 		// 	name: "會員分級",
  // 		// 	component: () => import('@/views/Subscription/MemberLevel.vue'),
  // 		// 	meta: {
  // 		// 		breadcrumbs: [
  // 		// 			{
  // 		// 				"text": "訂閱"
  // 		// 			},
  // 		// 			{
  // 		// 				"text": "會員分級"
  // 		// 			},
  // 		// 		]
  // 		// 	}
  // 		// }
  // 	]
  // },
  {
    name: '綁定 LINE 群組',
    path: '/:org_id/containers/bind-line-group',
    component: () => import('@/views/Setting/Container/BindLineGroup.vue'),
    invisibility_sidebar: true,
  },
  {
    path: '/:org_id/401',
    component: () => import('@/views/Error/Forbidden.vue'),
    invisibility_sidebar: true,
    name: 'Unauthorized',
    meta: {
      breadcrumbs: [
        {
          text: '無權限存取',
        },
      ],
    },
  },
  {
    path: '/:org_id/*',
    component: () => import('@/views/Error/NotFound.vue'),
    invisibility_sidebar: true,
    meta: {
      is_required_login: true,
    },
  },
  // {
  //     icon: "mdi-account-tie",
  // 	name: '數據-結帳金額',
  // 	path: '/demo',
  //     component: Demo,
  // 	feature: 'demo',
  // 	children: [

  // 	]
  // },
  // {
  //     icon: "mdi-account-tie",
  // 	name: '數據-結帳訂單號碼',
  // 	path: '/Oredernumber',
  //     component: TransactionId,
  // 	feature: 'Oredernumber',
  // 	children: [

  // 	]
  // },
  // {
  //     icon: "mdi-account-tie",
  // 	name: '建議文案',
  // 	path: '/copyWriting',
  //     component: CopyWriting,
  // 	feature: 'copyWriting',
  // 	children: [

  // 	]
  // },
  // {
  //     icon: "mdi-account-tie",
  // 	name: '缺貨提醒',
  // 	path: '/outOfStockrReminder',
  //     component: OutOfStockrReminder,
  // 	feature: 'outOfStockrReminder',
  // 	children: [

  // 	]
  // },
  // {
  //     icon: "mdi-account-tie",
  // 	name: '限定區域',
  // 	path: '/limitedArea',
  //     component: LimitedArea,
  // 	feature: 'limitedArea',
  // 	children: [

  // 	]
  // }
]

export { private_routes }
